/**
 * @generated SignedSource<<585bb3ba08ce3a33442e7bf8253ee0e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type Breadcrumb_post$data = {
  readonly holder_cemetery: {
    readonly name: string
  } | null
  readonly holder_city: {
    readonly name: string
  } | null
  readonly holder_prefecture: {
    readonly name: string
  } | null
  readonly ' $fragmentSpreads': FragmentRefs<
    | 'BreadcrumbForPost_post'
    | 'BreadcrumbForHolderCemetery_post'
    | 'BreadcrumbForHolderCity_post'
    | 'BreadcrumbForHolderPrefecture_post'
  >
  readonly ' $fragmentType': 'Breadcrumb_post'
}
export type Breadcrumb_post$key = {
  readonly ' $data'?: Breadcrumb_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'Breadcrumb_post'>
}

const node: ReaderFragment = (function () {
  var v0 = [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null
    }
  ]
  return {
    argumentDefinitions: [],
    kind: 'Fragment',
    metadata: null,
    name: 'Breadcrumb_post',
    selections: [
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'BreadcrumbForPost_post'
      },
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'BreadcrumbForHolderCemetery_post'
      },
      {
        alias: null,
        args: null,
        concreteType: 'Cemetery',
        kind: 'LinkedField',
        name: 'holder_cemetery',
        plural: false,
        selections: v0 /*: any*/,
        storageKey: null
      },
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'BreadcrumbForHolderCity_post'
      },
      {
        alias: null,
        args: null,
        concreteType: 'City',
        kind: 'LinkedField',
        name: 'holder_city',
        plural: false,
        selections: v0 /*: any*/,
        storageKey: null
      },
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'BreadcrumbForHolderPrefecture_post'
      },
      {
        alias: null,
        args: null,
        concreteType: 'HolderPrefecture',
        kind: 'LinkedField',
        name: 'holder_prefecture',
        plural: false,
        selections: v0 /*: any*/,
        storageKey: null
      }
    ],
    type: 'Post',
    abstractKey: null
  }
})()

;(node as any).hash = '7d8b850f8ee19bc76298acbc2b2470bb'

export default node
